import { Box } from "@mui/material";
import loader from "../../../assets/gif/loader.gif";

const LoadingOverlay = () => (
  <Box
    sx={{
      position: "fixed", // Changed from 'absolute' to 'fixed'
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      cursor: "wait",
      //   cursor: "not-allowed",
      pointerEvents: "all",
    }}
  >
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Box
        component="img"
        src={loader}
        alt="Loading..."
        sx={{ height: "50px", width: "50px" }}
      />
    </Box>
  </Box>
);

export default LoadingOverlay;
